import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getChatPostListByChatThreadId } from '@/service/chatPostService';
import { getCorporationById } from '@/service/organizationService';
import { getProjectById, getProjectListInCorporationByType, getUserListInProject } from '@/service/projectService';
import { getTicketById, getTicketDataGSI3WithFilter } from '@/service/ticketService';
import { getGeneralUserInProjectByProjectId, getUserById, getUserDeletedInfor } from '@/service/userService';
import { I18n } from 'aws-amplify';
import _, { cloneDeep } from 'lodash';
import { getTitle } from './DetailTicketHandler';

export const getTicketDetail = async (args, ticketId) => {
    const ticket = await getTicketById(args.API, ticketId,true);
    args.setTicketInfo(ticket);
    let userList = await getUserListInProject(
        args.API,
        ticket.projectOrigin
    );
    
    let delegatedUser = _.find(userList, function (user) {
        return user.id === ticket.proxiedUser;
    });

    if(Utils.isEmptyObject(delegatedUser)) {
        let creatorDetail = userList.find(user => user.id === ticket.creator)
        if(!Utils.isEmptyObject(creatorDetail)) {
            delegatedUser = creatorDetail;
        } else {
            creatorDetail = await getUserById(args.API, ticket.creator);
            userList.push(creatorDetail);
        }
    }
   
    args.setUserGuestList(userList);
    args.setUserDelegateCreateTicketDetail(delegatedUser ? delegatedUser : getUserDeletedInfor(ticket.creator,ticket.projectTarget));
};

export const groupThreadChatByType = async (args, ticketSelected, listThreadData, panelType) => {
    let selectThreadId = args.selectThreadId;
    const threadCustomerReference = listThreadData.find(
        x => x.threadType === Constant.THREAD_TYPE.CUSTOMER && x.ticketId !== ticketSelected.id
    );
    let ticketCustomerReference;
    if (threadCustomerReference) {
        ticketCustomerReference = await getTicketById(args.API, threadCustomerReference.ticketId,true);
        args.setTicketParent(ticketCustomerReference);
    }

    let customerReferenceThreadResult;
    let customerThreadResult;
    let internalThreadResult;
    let listEscalationThreadResult = [];
    if ((ticketSelected?.projectTarget).includes(args.projectId)) {
        args.setIsTargetProjectOfTicket(true);
    }
    let fistTabThreadChat = null;
    if (
        [
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER,
        ].includes(ticketSelected.ticketType)
    ) {
        //ticket user receive
        if ((ticketSelected?.projectTarget).includes(args.projectId) && !(panelType === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD && ticketSelected.affiliationProject === args.projectId)) {
            let threadCustomer = listThreadData.find(
                (x) => x.threadType === Constant.THREAD_TYPE.CUSTOMER
            );
            args.setCustomerThread(threadCustomer);
            customerThreadResult = threadCustomer;
            customerThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB;
            customerThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT;
            customerThreadResult.projectName = I18n.get('USER07BTN006');
            args.setTicketInfo(ticketSelected);
            if(!selectThreadId){
                args.setSelectThread(threadCustomer);
                selectThreadId = threadCustomer.id;
            }
        } else {
            let threadCustomer = listThreadData.find(
                (x) => x.threadType === Constant.THREAD_TYPE.CUSTOMER
            );
            args.setCustomerThread(threadCustomer);
            customerThreadResult = threadCustomer;
            customerThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB;
            customerThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT;
            customerThreadResult.projectName = I18n.get('USER07BTN006');
            args.setTicketInfo(ticketSelected);
            if(!selectThreadId){
                args.setSelectThread(threadCustomer);
                selectThreadId = threadCustomer.id;
            }
            let threadInternal = listThreadData.find(
                (x) => x.threadType === Constant.THREAD_TYPE.INTERNAL
            );
            args.setInternalThread(threadInternal);
            internalThreadResult = threadInternal;
            internalThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_TAB
            internalThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_CHAT
            internalThreadResult.projectName = I18n.get('USER07BTN007');
        }
    } else {
        //ticket user receive
        if ((ticketSelected?.projectTarget).includes(args.projectId)) {
            for (let thread of listThreadData) {
                if (
                    ((thread.threadType === Constant.THREAD_TYPE.CUSTOMER &&
                        thread.ticketId !== ticketSelected.id) ||
                    (listThreadData.length > 1 &&
                        thread.id === listThreadData[1].id &&
                        thread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                        thread.ticketId !== ticketSelected.id)) && Utils.isEmptyString(ticketCustomerReference?.deletedAt)
                ) {
                    fistTabThreadChat = thread;
                    if(!selectThreadId){
                        args.setSelectThread(fistTabThreadChat);
                        selectThreadId = fistTabThreadChat.id;
                        getTicketDetail(args, thread.ticketId);
                    }
                    args.setCustomerReferenceThread(thread);
                    customerReferenceThreadResult = thread;
                    customerReferenceThreadResult.colorTabThread = Constant.COLOR_THREAD_CHAT.REFERENCE_TAB;
                    customerReferenceThreadResult.colorChatThread = Constant.COLOR_THREAD_CHAT.REFERENCE_CHAT;
                    customerReferenceThreadResult.projectName = I18n.get('USER07BTN005');
                    if (!JSON.parse(ticketSelected.customersCustomer)?.ticketQA) {
                        customerReferenceThreadResult.hiddenTicketHeadLine = true;
                    }
                } else if (
                    (thread.threadType === Constant.THREAD_TYPE.CUSTOMER &&
                        thread.ticketId === ticketSelected.id) ||
                    (thread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                        thread.ticketId === ticketSelected.id)
                ) {
                    if (!fistTabThreadChat) {
                        if(!selectThreadId){
                            args.setSelectThread(thread);
                            selectThreadId = thread.id;
                        }
                        getTicketDetail(args, thread.ticketId);
                    }
                    args.setCustomerThread(thread);
                    customerThreadResult = thread;
                    customerThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB;
                    customerThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT;
                    customerThreadResult.projectName = I18n.get('USER07BTN006');
                    if (
                        args.userDetail.type !== Constant.USER_TYPE.CUSTOMER &&
                        ticketSelected.ticketType === Constant.TICKET_TYPE.DELEGATE
                    ) {
                        let threadDelegate = { ...thread };
                        threadDelegate.threadType = Constant.THREAD_TYPE.DELEGATE;
                        args.setDelegateThread(threadDelegate);
                    }
                } else if (
                    thread.threadType === Constant.THREAD_TYPE.INTERNAL &&
                    thread.ticketId === ticketSelected.id
                ) {
                    args.setInternalThread(thread);
                    internalThreadResult = thread;
                    internalThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_TAB
                    internalThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_CHAT
                    internalThreadResult.projectName = I18n.get('USER07BTN007');

                    if (ticketSelected.ticketType === Constant.TICKET_TYPE.TASK) {
                        selectThreadId = thread.id;
                        args.setSelectThread(thread);
                    }
                } else if (
                    thread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                    thread.ticketId !== ticketSelected.id
                ) {
                    const ticketData = await getTicketById(args.API, thread.ticketId,true);
                    const project = await getProjectById(args.API, ticketData?.projectTarget[0]);
                    if (project && thread.corporationId === args.corporationId) {
                        thread.projectName = Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            project.name
                        );
                    }
                    else {
                        const corpInfoExternal = await getCorporationById(args.API, thread.corporationId)
                        if(!Utils.isEmptyObject(corpInfoExternal)) {
                            thread.projectName = `${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                project.name)} (${Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    corpInfoExternal.name)})`
                        }
                    }

                    thread.colorTabThread = Constant.COLOR_THREAD_CHAT.ESCALATE_TAB
                    thread.colorChatThread = Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT
                    listEscalationThreadResult.push(thread);
                }
            }
            listEscalationThreadResult = renameDuplicateProjects(listEscalationThreadResult)
            args?.setEscalationThread([...listEscalationThreadResult]);
        } else {
            for (let thread of listThreadData) {
                if (
                    thread.threadType === Constant.THREAD_TYPE.CUSTOMER ||
                    (thread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                        thread.ticketId !== ticketSelected.id)
                ) {
                    if (!fistTabThreadChat) {
                        if(!selectThreadId){
                            args.setSelectThread(thread);
                            selectThreadId = thread.id;
                        }
                        getTicketDetail(args, thread.ticketId);
                    }
                    args.setCustomerThread(thread);
                    customerThreadResult = thread;
                    customerThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB
                    customerThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.CUSTOMER_CHAT
                    customerThreadResult.projectName = I18n.get('USER07BTN006');
                    
                    if (
                        args.userDetail.type !== Constant.USER_TYPE.CUSTOMER &&
                        ticketSelected.ticketType === Constant.TICKET_TYPE.DELEGATE
                    ) {
                        let threadDelegate = { ...thread };
                        threadDelegate.threadType = Constant.THREAD_TYPE.DELEGATE;
                        args.setDelegateThread(threadDelegate);
                    }
                } else if (
                    thread.threadType === Constant.THREAD_TYPE.INTERNAL &&
                    (thread.ticketId !== ticketSelected.id ||
                        ticketSelected.ticketType === Constant.TICKET_TYPE.INTERNAL_QA)
                ) {
                    args.setInternalThread(thread);
                    internalThreadResult = thread;
                    internalThreadResult.colorTabThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_TAB
                    internalThreadResult.colorChatThread =  Constant.COLOR_THREAD_CHAT.INTERNAL_CHAT
                    internalThreadResult.projectName = I18n.get('USER07BTN007');
                } else if (
                    thread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                    thread.ticketId === ticketSelected.id
                ) {
                    const ticketData = await getTicketById(args.API, thread.ticketId,true);
                    const project = await getProjectById(args.API, ticketData?.projectTarget[0]);
                    if (project && thread.corporationId === args.corporationId) {
                        thread.projectName = Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            project.name
                        );
                    }
                    else {
                        const corpInfoExternal = await getCorporationById(args.API, thread.corporationId)
                        if(!Utils.isEmptyObject(corpInfoExternal)) {
                            thread.projectName = `${Utils.getTextByLanguage(
                                Constant.LANGUAGE_TYPE.JP,
                                project.name)} (${Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    corpInfoExternal.name)})`
                        }
                    }

                    thread.colorTabThread = Constant.COLOR_THREAD_CHAT.ESCALATE_TAB
                    thread.colorChatThread = Constant.COLOR_THREAD_CHAT.ESCALATE_CHAT
                    if(selectThreadId === thread.id){
                        args.setTicketInfo(ticketData);
                    }

                    listEscalationThreadResult.push(thread);
                }
            }
            if (args?.setEscalationThread) {
                args?.setEscalationThread([...listEscalationThreadResult]);
            }
        }
    }

    if (selectThreadId) {
        let threadSelect = listThreadData.find(x => x.id === selectThreadId);
        
        if (threadSelect) {
            args.setSelectThread(threadSelect);

            if (
                ((threadSelect.threadType === Constant.THREAD_TYPE.CUSTOMER &&
                    threadSelect.ticketId !== ticketSelected.id) ||
                    (listThreadData.length > 1 &&
                        threadSelect.id === listThreadData[1].id &&
                        threadSelect.threadType === Constant.THREAD_TYPE.ESCALATION &&
                        threadSelect.ticketId !== ticketSelected.id)) &&
                Utils.isEmptyString(ticketCustomerReference?.deletedAt)
            ) {
                getTicketDetail(args, threadSelect.ticketId);
            } else if (
                (threadSelect.threadType === Constant.THREAD_TYPE.CUSTOMER &&
                    threadSelect.ticketId === ticketSelected.id) ||
                (threadSelect.threadType === Constant.THREAD_TYPE.ESCALATION &&
                    threadSelect.ticketId === ticketSelected.id)
            ) {
                getTicketDetail(args, threadSelect.ticketId);
            } else {
                args.setTicketInfo(ticketSelected);
            }
        }
    }

    args.setTicketOriginInfor(ticketSelected);

    return {
        customerReferenceThreadResult,
        customerThreadResult,
        internalThreadResult,
        listEscalationThreadResult,
        selectThreadId
    };
};

function renameDuplicateProjects(threadsDetail = []) {
    const nameIndex = new Map();

    if (threadsDetail?.length <= 0) return [];

    return threadsDetail?.map(obj => {
        let { projectName } = obj;

        if (!projectName) return obj;

        let count = nameIndex.get(projectName) || 0;

        if (count > 0) {
            obj = { ...obj, projectName: `${projectName} (${count})` };
        }

        nameIndex.set(projectName, count + 1);
        return obj;
    });
}

const getListUserIsCustomerOfTicketQA = async (API, customerTicket) => {
    let listUser = [];
    let prefixOfId = Utils.getPrefixOfId(customerTicket);
    if (prefixOfId === 'user') {
        let customerDetail = await getUserById(API, customerTicket);
        if (!Utils.isEmptyObject(customerDetail) && customerDetail.active !== Constant.ACTIVE_FLAG.DELETED) {
            listUser.push(customerDetail);
        }
    } else if (prefixOfId === 'project') {
        //customer of Ticket is project => get user in project customer of ticket
        let listUserInCustomerProject = await getGeneralUserInProjectByProjectId(
            API,
            customerTicket
        );
        if (!Utils.isEmptyArray(listUserInCustomerProject)) {
            listUser = [...listUserInCustomerProject];
        }
    }

    return listUser;
};

const getUserListCanMentionForInternalQA = async (
    API,
    selectThread,
    ticketOriginInfor,
    selectedProjectId,
    ticketInfo
) => {
    let listMention = [];
    let listProjectSubscription = [];

    if (ticketOriginInfor.projectTarget.includes(selectedProjectId)) {
        // ticket Internal QA view form Helpdesk
        if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
            // get general in project Inuse
            listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);

            let customerTicket = ticketOriginInfor.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );

            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        // } else if (selectThread.threadType === Constant.THREAD_TYPE.ESCALATION) {
        //     listMention = await getGeneralUserInProjectByProjectId(
        //         API,
        //         ticketInfo.affiliationProject
        //     );
        //     if (ticketInfo.affiliationOrganization !== ticketOriginInfor.affiliationOrganization) {
        //         listMention = listMention?.filter(user => user.agent === Constant.AGENT_FLAG.TRUE);
        //     }
        //     listProjectSubscription.push(selectedProjectId);
        } else {
            listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
            listProjectSubscription.push(selectedProjectId);
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        }
    } else {
        listMention = await getGeneralUserInProjectByProjectId(API, ticketOriginInfor.projectTarget[0]);
        listProjectSubscription.push(ticketOriginInfor.projectTarget[0]);
    }

    return {
        listMention,
        listProjectSubscription
    };
};

const getUserListCanMentionForExternalQA = async (
    API,
    selectThread,
    ticketOriginInfor,
    selectedProjectId
) => {
    let listMention = [];
    let listProjectSubscription = [];

    if (ticketOriginInfor.projectTarget.includes(selectedProjectId)) {
        // ticket Internal QA view form Helpdesk
        if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
            // get general in project Inuse
            listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
            // filer
            // listMention = listMention?.filter(user => user.agent === Constant.AGENT_FLAG.TRUE);

            let customerTicket = ticketOriginInfor.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );

            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }
        } else {
            listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
            listProjectSubscription.push(selectedProjectId);
        }
        listMention.unshift(Constant.CHAT_MENTION_ALL);
    } else {
        listMention = await getGeneralUserInProjectByProjectId(API, ticketOriginInfor.projectTarget[0]);
        // filer
        // listMention = listMention?.filter(user => user.agent === Constant.AGENT_FLAG.TRUE);
        listProjectSubscription.push(ticketOriginInfor.projectTarget[0]);
    }

    return {
        listMention,
        listProjectSubscription
    };
};

const getUserListCanMentionForInternalEscalation = async (
    API,
    selectThread,
    ticketInfo,
    ticketOriginInfor,
    selectedProjectId
) => {
    let listMention = [];
    let listProjectSubscription = [];
    let listGeneralUserOfProjectSelected = await getGeneralUserInProjectByProjectId(
        API,
        selectedProjectId
    );

    // view ticket escalate form Helpdesk panel
    if (ticketOriginInfor.projectTarget.includes(selectedProjectId)) {
        if (
            selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER ||
            (selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                selectThread.ticketId === ticketOriginInfor.id)
        ) {
            listMention = listGeneralUserOfProjectSelected;

            let customerTicket = ticketOriginInfor.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );
            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }

            listMention.unshift(Constant.CHAT_MENTION_ALL);
        } else {
            listMention = listGeneralUserOfProjectSelected;
            listMention.unshift(Constant.CHAT_MENTION_ALL);

            listProjectSubscription.push(selectedProjectId);
        }
    } else {
    // view ticket escalate form Customer panel
        if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
            // get general in project Inuse
            listMention = listGeneralUserOfProjectSelected;

            let customerTicket = ticketInfo.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );
            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        } else if (selectThread.threadType === Constant.THREAD_TYPE.INTERNAL) {
            listMention = listGeneralUserOfProjectSelected;
            listProjectSubscription.push(selectedProjectId);
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        } else if (selectThread.threadType === Constant.THREAD_TYPE.ESCALATION) {
            // can mention to list user of project target
            listMention = await getGeneralUserInProjectByProjectId(
                API,
                ticketInfo.affiliationProject
            );
            listMention.unshift(Constant.CHAT_MENTION_ALL);
            
            listProjectSubscription.push(selectedProjectId);
        }
    }

    return {
        listMention,
        listProjectSubscription
    };
};

const getUserListCanMentionForExternalEscalation = async (
    API,
    selectThread,
    ticketInfo,
    ticketOriginInfor,
    selectedProjectId
) => {
    let listMention = [];
    let listProjectSubscription = [];

    let listGeneralUserOfProjectSelected = await getGeneralUserInProjectByProjectId(
        API,
        selectedProjectId
    );

    // view ticket escalate form Helpdesk
    if (ticketOriginInfor.projectTarget.includes(selectedProjectId)) {
        if (
            selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER ||
            (selectThread.threadType === Constant.THREAD_TYPE.ESCALATION &&
                selectThread.ticketId === ticketOriginInfor.id)
        ) {
            // listMention = listGeneralUserOfProjectSelected.filter(
            //     user => user.agent === Constant.AGENT_FLAG.TRUE
            // );

            let customerTicket = ticketOriginInfor.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );
            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }
        } else {
            listMention = listGeneralUserOfProjectSelected;
            listProjectSubscription.push(selectedProjectId);
        }
        listMention.unshift(Constant.CHAT_MENTION_ALL);
    } else {
        if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
            // get general in project Inuse
            listMention = listGeneralUserOfProjectSelected;

            let customerTicket = ticketInfo.customer;
            let listUserIsCustomerOfTicketQA = await getListUserIsCustomerOfTicketQA(
                API,
                customerTicket
            );
            listMention = [...listMention, ...listUserIsCustomerOfTicketQA];

            listProjectSubscription.push(selectedProjectId);
            if (Utils.getPrefixOfId(customerTicket) === 'project') {
                listProjectSubscription.push(customerTicket);
            }
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        } else if (selectThread.threadType === Constant.THREAD_TYPE.INTERNAL) {
            listMention = listGeneralUserOfProjectSelected;
            listProjectSubscription.push(selectedProjectId);
            listMention.unshift(Constant.CHAT_MENTION_ALL);
        } else if (selectThread.threadType === Constant.THREAD_TYPE.ESCALATION) {
            listMention = await getGeneralUserInProjectByProjectId(
                API,
                ticketInfo.affiliationProject
            );
            // listMention = listMention.filter(
            //     user => user.agent === Constant.AGENT_FLAG.TRUE
            // );
            listProjectSubscription.push(selectedProjectId);
        }
    }

    return {
        listMention,
        listProjectSubscription
    };
};

const getUserListCanMentionForNotice = async (
    API,
    selectThread,
    ticketInfo,
    selectedProjectId,
    customerNoticeData,
    corporationDetail,
    userDetail
) => {
    let listMention = [];
    let listProjectSubscription = [];

    let customerNoticeDataValue = JSON.parse(customerNoticeData.dataValue).value;
    let prefixOfId = Utils.getPrefixOfId(customerNoticeDataValue);

    // view ticket notice from Helpdesk
    if (ticketInfo.projectOrigin === selectedProjectId) {
        if (selectThread.threadType === Constant.THREAD_TYPE.CUSTOMER) {
            // case notice to All
            if (prefixOfId !== 'user' && prefixOfId !== 'project') {
                listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
                // if(customerNoticeDataValue === 'AllCustomerProject' || customerNoticeDataValue === 'AllGuestCustomerUser') {
                //     listMention = listMention?.filter(
                //         user => user.agent === Constant.AGENT_FLAG.TRUE
                //     );
                // }

                listProjectSubscription.push(selectedProjectId);
            } else {
                listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
                if (prefixOfId === 'user') {
                    let userNoticeDetail = await getUserById(API, customerNoticeDataValue);
                    if (
                        !Utils.isEmptyObject(userNoticeDetail) &&
                        (Utils.isGeneralUserWithoutGuest(userNoticeDetail) ||
                            userNoticeDetail.type === Constant.USER_TYPE.INTERNAL)
                    ) {
                        // isNoticeInternal
                        listMention.push(userNoticeDetail);
                    } else {
                        // isNoticeExternal => get user in helpDesk
                        // listMention = listMention?.filter(
                        //     user => user.agent === Constant.AGENT_FLAG.TRUE
                        // );
                        listMention.push(userNoticeDetail);
                    }
                } else {
                    let projectNoticeDetail = await getProjectById(API, customerNoticeDataValue);
                    if (
                        !Utils.isEmptyObject(projectNoticeDetail) &&
                        projectNoticeDetail.affiliationOrganization === corporationDetail.id
                    ) {
                        // isNoticeInternal
                        let listUserInProjectNotice = await getGeneralUserInProjectByProjectId(
                            API,
                            projectNoticeDetail.id
                        );
                        listMention = [...listMention, ...listUserInProjectNotice];

                        listProjectSubscription.push(projectNoticeDetail.id);
                    } else {
                        // isNoticeExternal
                        // listMention = listMention?.filter(
                        //     user => user.agent === Constant.AGENT_FLAG.TRUE
                        // );
                        let listUserInProjectNotice = await getGeneralUserInProjectByProjectId(
                            API,
                            projectNoticeDetail.id
                        );
                        listMention = [...listMention, ...listUserInProjectNotice];
                        listProjectSubscription.push(projectNoticeDetail.id);
                    }
                }
            }
        } else {
            listMention = await getGeneralUserInProjectByProjectId(API, selectedProjectId);
            listProjectSubscription.push(selectedProjectId);
        }
        listMention.unshift(Constant.CHAT_MENTION_ALL);

        // view ticket notice from Customer
    } else {
        // isNoticeExternal => get user in helpDesk
        listMention = await getGeneralUserInProjectByProjectId(API, ticketInfo.projectOrigin);
        // if (
        //     Utils.isGeneralUserWithoutGuest(userDetail) &&
        //     userDetail.type !== Constant.USER_TYPE.INTERNAL
        // ) {
        //     listMention = listMention?.filter(user => user.agent === Constant.AGENT_FLAG.TRUE);
        // }
        listProjectSubscription.push(ticketInfo.projectOrigin);
    }

    return {
        listMention,
        listProjectSubscription
    };
};

/**
 * Get project by Organization active
 * @param {*} API 
 * @param {*} projectIds 
 * @returns 
 */
const getProjectByOrganizationActive = async (API, projectIds) => {
    if(!projectIds.length) return []
    const listProjectValid = [];
    await Promise.all(projectIds.map(async (projectId) => {
        const project = await getProjectById(API, projectId);
        const org = await getCorporationById(API, project?.affiliationOrganization)
        if(org?.active === Constant.CORPORATION_ACTIVE.ACTIVE) listProjectValid.push(projectId);
        return org;
    }));
    return listProjectValid;
}

/**
 * Get list projectId user can view in chat thread
 * @param {*} API 
 * @param {*} ticket 
 * @param {*} corporationDetail 
 * @param {*} listB2BCustomer 
 * @param {*} listB2BHelpdesk 
 * @returns 
 */
const getProjectsCanViewChatThread = async (
    API,
    ticket,
    corporationDetail,
    listB2BCustomer,
    listB2BHelpdesk
) => {
    const projectIds = [];
    if (!ticket?.viewPermission?.length) return [];
    const viewPermission = ticket?.viewPermission;
    const additionalViewPermission = Utils.convertJSONDataToObject(
        ticket?.additionalViewPermission
    );
    if (!Utils.isEmptyObject(additionalViewPermission)) {
        for (let [_, value] of Object.entries(additionalViewPermission)) {
            if (value?.length) projectIds.push(...value);
        }
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER)) {
        if (listB2BCustomer?.length) {
            listB2BCustomer.forEach(p => projectIds.push(p?.projectId));
        }
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT)) {
        if (listB2BHelpdesk?.length) {
            listB2BHelpdesk.forEach(p => projectIds.push(p?.projectId));
        }
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT)) {
        projectIds.push(ticket.affiliationProject);
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)) {
        const projects = await getProjectListInCorporationByType(API, corporationDetail.id, [
            Constant.PROJECT_TYPE.GENERAL
        ]);
        projectIds.push(...projects.map(project => project.id));
    }
    if (viewPermission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) {
        const projects = await getProjectListInCorporationByType(API, corporationDetail.id, [
            Constant.PROJECT_TYPE.GENERAL,
            Constant.PROJECT_TYPE.BASE,
            Constant.PROJECT_TYPE.CUSTOMER
        ]);
        projectIds.push(...projects.map(project => project.id));
        if (listB2BCustomer?.length) {
            listB2BCustomer.forEach(p => projectIds.push(p?.projectId));
        }
        if (listB2BHelpdesk?.length) {
            listB2BHelpdesk.forEach(p => projectIds.push(p?.projectId));
        }
    }
    const result = [];
    projectIds.forEach(project => {
        if(!result.includes(project)) result.push(project);
    });
    return result;
};

/**
 * Get list user can mention in chat thread ticket knowledge
 * @param {*} params 
 * @returns 
 */
const getUserListCanMentionForTicketKnowledge = async (params) => {
    const {
        API,
        ticketInfo,
        selectedProjectId,
        corporationDetail,
        listB2BCustomer,
        listB2BHelpdesk
    } = params;
    
    let listMention = [];
    let projectIds = [];
    const chatPermission = ticketInfo?.chatPermission;
    const projectCanViewIds = await getProjectsCanViewChatThread(API, ticketInfo, corporationDetail, listB2BCustomer, listB2BHelpdesk);
    switch (chatPermission) {
        case Constant.KNOWLEDGE_CHAT_PERMISSION.NO:
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT:
            projectIds.push(selectedProjectId);
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG:
            const projects = await getProjectListInCorporationByType(API, corporationDetail.id, [
                Constant.PROJECT_TYPE.GENERAL
            ]);
            projectIds.push(...projects.map(project => project.id));
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC: {
            const activeB2BCustomerList = ticketInfo?.activeB2BCustomerList || [];
            const activeB2BSupportList = ticketInfo?.activeB2BSupportList || [];
            const listProject = await getProjectListInCorporationByType(API, corporationDetail.id, [
                Constant.PROJECT_TYPE.GENERAL,
                Constant.PROJECT_TYPE.BASE,
                Constant.PROJECT_TYPE.CUSTOMER
            ]);
            if (listB2BCustomer?.length) {
            listB2BCustomer.forEach(p => projectIds.push(p?.projectId));
        }
        if (listB2BHelpdesk?.length) {
            listB2BHelpdesk.forEach(p => projectIds.push(p?.projectId));
        }
            let allProjectIds = [
                ...activeB2BCustomerList,
                ...activeB2BSupportList,
                ...listProject.map(project => project.id)
            ];
            if (listB2BCustomer?.length) {
                listB2BCustomer.forEach(p => allProjectIds.push(p?.projectId));
            }
            if (listB2BHelpdesk?.length) {
                listB2BHelpdesk.forEach(p => allProjectIds.push(p?.projectId));
            }
            projectIds.push(...[...new Set(allProjectIds)])
            break;
        }
        case Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION: {
            projectIds.push(...projectCanViewIds);
            break;
        }
        default:
            break;
    }
    if(chatPermission !== Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION) {
        projectIds = projectIds.filter(project => projectCanViewIds.includes(project));
    }
    projectIds = await getProjectByOrganizationActive(API, projectIds);
    const allUser = await Promise.all(
        projectIds.map(async projectId => {
            return getGeneralUserInProjectByProjectId(API, projectId);
        })
    );
    allUser.forEach(user => listMention.push(...user));
    if(listMention.length) listMention.unshift(Constant.CHAT_MENTION_ALL);
    return { listMention, listProjectSubscription: [] };
};

/**
 * Get list user can mention in chat thread
 * @param {*} props
 * @returns
 */
export const getUserListCanMention = async props => {
    let {
        API,
        selectThread,
        ticketInfo,
        ticketOriginInfor,
        selectedProjectId,
        userDetail,
        corporationDetail
    } = props;
    try {
        let getDataResult = {};
        let listMention = [];
        let listProjectSubscription = [];
        switch (ticketOriginInfor.ticketType) {
            case Constant.TICKET_TYPE.INTERNAL_QA:
                getDataResult = await getUserListCanMentionForInternalQA(
                    API,
                    selectThread,
                    ticketOriginInfor,
                    selectedProjectId,
                    ticketInfo
                );
                break;
            case Constant.TICKET_TYPE.QA:
            case Constant.TICKET_TYPE.EXTERNAL_QA:
                getDataResult = await getUserListCanMentionForExternalQA(
                    API,
                    selectThread,
                    ticketOriginInfor,
                    selectedProjectId
                );

                break;
            case Constant.TICKET_TYPE.DELEGATE:
                let projectOriginDetail = await getProjectById(
                    API,
                    ticketOriginInfor.projectOrigin
                );
                if (
                    projectOriginDetail.affiliationOrganization !==
                        ticketOriginInfor.affiliationOrganization ||
                    projectOriginDetail.type === Constant.PROJECT_TYPE.CUSTOMER ||
                    Utils.isProjectGuest(projectOriginDetail)
                ) {
                    getDataResult = await getUserListCanMentionForExternalQA(
                        API,
                        selectThread,
                        ticketOriginInfor,
                        selectedProjectId
                    );
                } else {
                    getDataResult = await getUserListCanMentionForInternalQA(
                        API,
                        selectThread,
                        ticketOriginInfor,
                        selectedProjectId,
                        ticketInfo
                    );
                }

                break;
            case Constant.TICKET_TYPE.ESCALATION:
                if (
                    ticketOriginInfor.affiliationOrganization === ticketInfo.affiliationOrganization
                ) {
                    getDataResult = await getUserListCanMentionForInternalEscalation(
                        API,
                        selectThread,
                        ticketInfo,
                        ticketOriginInfor,
                        selectedProjectId
                    );
                } else {
                    getDataResult = await getUserListCanMentionForExternalEscalation(
                        API,
                        selectThread,
                        ticketInfo,
                        ticketOriginInfor,
                        selectedProjectId
                    );
                }

                break;
            case Constant.TICKET_TYPE.BROADCAST_CHILD:
            case Constant.TICKET_TYPE.BROADCAST_PARENT:
                let parentId =
                    ticketOriginInfor.ticketType === Constant.TICKET_TYPE.BROADCAST_PARENT
                        ? ticketOriginInfor.id
                        : ticketOriginInfor.parent;
                let customerNoticeData = await getTicketDataGSI3WithFilter(
                    API,
                    parentId,
                    Constant.TICKET_DATA_TYPE.FIELD,
                    Constant.TICKET_DATA_ID.CUSTOMER_NOTICE
                );

                if (!Utils.isEmptyArray(customerNoticeData)) {
                    getDataResult = await getUserListCanMentionForNotice(
                        API,
                        selectThread,
                        ticketOriginInfor,
                        selectedProjectId,
                        customerNoticeData[0],
                        corporationDetail,
                        userDetail
                    );
                }

                break;
            case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
            case Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT:
            case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
            case Constant.TICKET_TYPE.INVITATION_GUEST_CUSTOMER:
                break;
            case Constant.TICKET_TYPE.MASTER_KNOWLEDGE:
            case Constant.TICKET_TYPE.KNOWLEDGE: {
                getDataResult = await getUserListCanMentionForTicketKnowledge({
                    API,
                    ticketInfo,
                    selectedProjectId,
                    corporationDetail,
                    listB2BCustomer: props?.listB2BCustomerRecoilState,
                    listB2BHelpdesk: props?.listB2BHelpdeskRecoilState
                });
                break;
            }
            case Constant.TICKET_TYPE.TASK:
                getDataResult = await getUserListCanMentionForTicketTask(API, ticketOriginInfor);
                break;
            case Constant.TICKET_TYPE.EMAIL:
            case Constant.TICKET_TYPE.EMAIL_REPLY:
                getDataResult = await getUserListCanMentionForTicketEmail(API, ticketOriginInfor);
                break;
            default:
                break;
        }

        if (!getDataResult || Utils.isEmptyObject(getDataResult)) return [];

        listMention = getDataResult.listMention;
        listMention = listMention.reduce((unique, o) => {
            if (!unique.some(obj => obj.id === o.id)) {
                unique.push(o);
            }
            return unique;
        }, []);
        listMention = listMention.filter(user => user.id !== userDetail.id);
        listMention = sortListMentionByNameAsc(listMention);
        listProjectSubscription = getDataResult.listProjectSubscription;
        props.setProjectIdListForSubscriptionMention(listProjectSubscription);
    
        return listMention;
    } catch (error) {
        console.log('getUserListCanMention ~ error :>>', error);
        return [];
    }
};

const sortListMentionByNameAsc = (listMention) => {
    return listMention.sort((a, b) => {
        let nameA = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, a);
        let nameB = Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, b);
        return nameA.localeCompare(nameB);
    });
}

/**
 * When receive subscription result is new user in project, add to list can mention
 * @param {*} args
 * @param {*} userProjectUpdate
 */
export const addMentionUserToList = async(args, userProjectUpdate) => {
    let userListCanMentionClone = cloneDeep(args.userListCanMention);
    let userChatListClone = cloneDeep(args.userChatList);

    if (!userListCanMentionClone.find(user => user.id === userProjectUpdate.id2)) {
        let newUserMention = userChatListClone.find(user => user.id === userProjectUpdate.id2);

        if (!Utils.isEmptyObject(newUserMention) && newUserMention.active === 1) {
            userListCanMentionClone.push(newUserMention);
            userListCanMentionClone = sortListMentionByNameAsc(userListCanMentionClone);
            args.setUserListCanMention(userListCanMentionClone);
            return;
        }

        getUserById(args.API, userProjectUpdate.id2).then(async userDetail => {
            if (!Utils.isEmptyObject(userDetail) && userDetail.active === 1) {
                let avatar = Constant.AVATAR_DEFAULT;
                if (!Utils.isEmptyString(userDetail.image)) {
                    avatar = await Storage.get(userDetail.image);
                }
                userDetail.avatar = avatar;

                userListCanMentionClone.push(userDetail);
                userListCanMentionClone = sortListMentionByNameAsc(userListCanMentionClone);
                args.setUserListCanMention(userListCanMentionClone);

                userChatListClone.push(userDetail);
                args.setUserChatList(userChatListClone);
            }
        });
    }
};

/**
 * When user is deleted form project, remove user from list can mention
 * @param {*} args
 * @param {*} userProjectDelete
 */
export const removeMentionUserFromList = (args, userProjectDelete) => {
    let userListCanMentionClone = cloneDeep(args.userListCanMention);
    userListCanMentionClone = userListCanMentionClone.filter(
        user => user.id !== userProjectDelete.id2
    );
    args.setUserListCanMention(userListCanMentionClone);
};

export const getVisibleWidth = (item) => {
    const container = document.querySelector(`.MuiTabs-flexContainer`);
    let containerRect = container.getBoundingClientRect();
    let elements = document.querySelector(`.navTabs--item-${item.data.id}`);
    let eleRect = elements.getBoundingClientRect();
    let rect = {};
    rect.top = eleRect.top - containerRect.top;
    rect.right = eleRect.right - containerRect.right;
    rect.bottom = eleRect.bottom - containerRect.bottom;
    rect.left = eleRect.left - containerRect.left;
    rect.width = eleRect.width;
    return rect;
}

export const scrollToActiveTab = (nextIndex, tabList, selectThreadId) => {
    const currentIndex = tabList.findIndex(tab => tab.data.id === selectThreadId);
    // if (!currentIndex) return;
    const element = document.querySelector(`.MuiTabs-flexContainer`);
    let containerRect = element.getBoundingClientRect();
    let posElem = [];
    for (let i = 0; i < tabList.length; i++) {
        let visiblePageWidth = getVisibleWidth(tabList[i]);
        posElem.push({ pos: visiblePageWidth });
    }
    let isRightPosItem = nextIndex - currentIndex > 0 ? true : false;

    if (isRightPosItem) {
        if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width > containerRect.width) {
            element.scrollLeft +=
                posElem[nextIndex].pos.width -
                (containerRect.width - posElem[nextIndex].pos.left);
        }
    } else {
        if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width <= containerRect.width) {
            element.scrollLeft += posElem[nextIndex].pos.left;
        }
    }
}

export  const handlerChangeTabThreadChat = async(thread, props, projectId) => {
    props.setSelectThread(thread);
    props.setIsLoading(true);
    const ticket = await getTicketById(props?.API, thread.ticketId, true);
    props.setTicketInfo(ticket);

    if(!props.isShowAllChatPost) {
        let fromStart = 0;
        props.setFromMsg(fromStart);
        getChatPostListByChatThreadId(props?.API, [thread.id], fromStart, projectId).then(async posts => {
            if (!Utils.isEmptyObject(posts)) {
                props.setUserChatList(posts.userChatList);
                props.setChatPostAllList({
                    type: Constant.ACTION_CHANGE_LIST_DATA_TYPE.INITIAL,
                    posts: posts ? posts.chatPostAllList : []
                });
                props.setLastedCountList(posts.chatPostAllList.length);
            }
            props.setIsLoading(false);
        });
    } else {
        props.setIsLoading(false);
    }
}

export const getTheadCustomerText = (thread, ticketOriginInfor) => {
    if (
        !Utils.isEmptyObject(thread) &&
        !Utils.isEmptyObject(ticketOriginInfor?.ticketDetail) &&
        ticketOriginInfor?.ticketDetail.ticketType === Constant.TICKET_TYPE.INTERNAL_QA
    ) {
        return '問い合せ対応';
    }
    return I18n.get('USER07BTN006');
};

function getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    let context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

export const cutTextByWidth = (text, textFont, widthCut) => {
    let array = Array.from(text);

    let textRes = '';
    let sunWidth = 0;

    let index = 0;
    for (index = 0; index < array.length; index++) {
        const item = array[index];
        let widthItem = getTextWidth(item, textFont);

        sunWidth = sunWidth + widthItem;
        textRes = `${textRes}${item}`;

        if(sunWidth >= widthCut) {
            break;
        }
    }

    let res = {
        value: textRes,
        index: index
    };

    return res;
}

export const generateTicketTitle = (ticket,numberLine,font) => {
    
    let maxRow = 2;
    let textFont =font ? font : '500 16px Zen Kaku Gothic New';

    let titleElementSelector = document.querySelector(`.contentPanel`);
    let titleBoundingClient = titleElementSelector?.getBoundingClientRect();
    let maxWidthTitle = titleBoundingClient.width - 270;

    let titleResults = [];
    let currentRow = 0;
    let restValue = '';

    let settingTitle = cloneDeep(ticket.settingTitle);
    let fullTitle = getTitle(settingTitle)
    if (Utils.isEmptyArray(settingTitle)) return '';

    for (let i = 0; i < settingTitle.length; i++) {
        if (currentRow >= maxRow) break;

        let itemSetting = settingTitle[i];
        let currentRowValue = !Utils.isEmptyString(titleResults[currentRow])
            ? titleResults[currentRow]
            : '';
        let currentRowWidth = !Utils.isEmptyString(currentRowValue)
            ? getTextWidth(currentRowValue, textFont)
            : 0;

        if (itemSetting.isBreak) {
            if (currentRowValue === '') {
                // titleResults.push('');
            } else {
                titleResults[currentRow] = `${currentRowValue}\n`;
                currentRow++;
            }
            continue;
        }

        let textValue = itemSetting.text;
        
        if (Utils.isEmptyString(textValue)) {
            continue;
        }
        let textWidth = getTextWidth(textValue, textFont);

        let deviantWidth = Number(maxWidthTitle) - Number(currentRowWidth + textWidth);
        
        if (deviantWidth === 0) {
            currentRowValue = `${currentRowValue} ${textValue}\n`;
            titleResults[currentRow] = currentRowValue;

            currentRow++;
        } else if (deviantWidth > 0) {
            currentRowValue = `${currentRowValue}${textValue}`;
            titleResults[currentRow] = currentRowValue;
        } else {
            currentRowValue = `${currentRowValue}${textValue}`;

            let cutRes = cutTextByWidth(currentRowValue, textFont, maxWidthTitle);

            let cutTextVal = cutRes.value;
            titleResults[currentRow] = `${cutTextVal}\n`;
            currentRow++;
            if (currentRow >= maxRow) break;

            restValue = currentRowValue.slice(cutRes.index + 1, currentRowValue.length);

            let settingNext = cloneDeep(settingTitle[i + 1]);
            if (settingNext) {
                settingTitle[i + 1].text = `${restValue}${settingNext.text}`;
            }else{
                if(i+1 === settingTitle.length && currentRow < maxRow){
                    
                    let lastText = cutTextByWidth(restValue, textFont, maxWidthTitle)
                    titleResults[currentRow+1] = `${lastText.value}\n`
                }
            }
        }
    }
    let title = titleResults.join(' ');
    if(title?.trim()?.length < fullTitle?.trim().length){
        let lastPartTitle = titleResults[titleResults.length -1]
        lastPartTitle = lastPartTitle.slice(0, -3);
        lastPartTitle = lastPartTitle + '...'
        titleResults[titleResults.length -1] = lastPartTitle
    }
    return titleResults;
};


const getUserListCanMentionForTicketTask = async (
    API,
    ticketInfo
) => {
    let listMention = [];
    let listProjectSubscription = [];

    if (ticketInfo?.projectOrigin) {
        listMention = await getGeneralUserInProjectByProjectId(API, ticketInfo.projectOrigin);
        listMention.unshift(Constant.CHAT_MENTION_ALL);
        listProjectSubscription.push(ticketInfo.projectOrigin);
    }

    return {
        listMention,
        listProjectSubscription
    };
};

const getUserListCanMentionForTicketEmail = async (API, ticketInfo) => {
    let listMention = [];
    let listProjectSubscription = [];

    if (ticketInfo?.affiliationProject) {
        listMention = await getGeneralUserInProjectByProjectId(API, ticketInfo.affiliationProject);
        listMention.unshift(Constant.CHAT_MENTION_ALL);
        listProjectSubscription.push(ticketInfo.affiliationProject);
    }

    return {
        listMention,
        listProjectSubscription
    };
}